__turbopack_context__.v({
  "badge": "M4r_XW_badge",
});
